export default {"src":"/_next/static/media/calendarCancel_64.bba6ff3a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};